import { AlertTriangle, Inbox, LoaderCircle, LockKeyhole } from 'lucide-react'
import type { ReactNode } from 'react'

export type PreviewState = 'ready' | 'loading' | 'error' | 'empty'

interface StatePanelProps {
  icon: ReactNode
  title: string
  description: string
  action?: ReactNode
}

function StatePanel({ icon, title, description, action }: StatePanelProps) {
  return (
    <section className="state-panel" role="status">
      <span className="state-panel__icon">{icon}</span>
      <h2>{title}</h2>
      <p>{description}</p>
      {action}
    </section>
  )
}

export function LoadingState() {
  return <StatePanel icon={<LoaderCircle className="spin" />} title="正在準備內容" description="請稍候，資料載入完成後會自動顯示。" />
}

export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  return (
    <StatePanel
      icon={<AlertTriangle />}
      title="暫時無法取得資料"
      description="連線可能不穩定，請稍後再試。系統不會把失敗操作當成成功。"
      action={onRetry ? <button className="primary-button" onClick={onRetry}>重新載入</button> : undefined}
    />
  )
}

export function EmptyState() {
  return <StatePanel icon={<Inbox />} title="這裡還沒有內容" description="有新資料時會顯示在這裡。" />
}

export function ForbiddenState() {
  return <StatePanel icon={<LockKeyhole />} title="沒有查看權限" description="此頁需要指定角色與組織範圍。請返回功能中心或聯絡管理者。" />
}

export function PreviewBoundary({ state, children }: { state: PreviewState; children: ReactNode }) {
  if (state === 'loading') return <LoadingState />
  if (state === 'error') return <ErrorState />
  if (state === 'empty') return <EmptyState />
  return children
}
